(() => {
  'use strict';
  const config = document.currentScript.dataset;
  const forms = { en: 'TxUQYi', de: 'Tvbiu7', nl: 'WSY8Wb', fr: 'VCW3GV' };
  const ids = Object.values(forms);
  const key = 'cc_eu_engraving_dismissed';
  let dismissed = false;
  function isDismissed() {
    try { return dismissed || localStorage.getItem(key) === '1'; }
    catch (_) { return true; } // Without storage, do not repeatedly interrupt visitors.
  }
  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail || {};
    if (!ids.includes(detail.formId)) return;
    if (['close', 'submit', 'redirectedToUrl'].includes(detail.type)) {
      dismissed = true;
      try { localStorage.setItem(key, '1'); } catch (_) {}
    }
  });
  if (config.home !== 'true' || config.customer === 'true' || isDismissed()) return;
  const initialPath = location.pathname;
  const language = config.language.split('-')[0];
  const formId = forms[language] || forms.en;
  const root = config.root.replace(/\/?$/, '/');
  let attempts = 0;
  async function showOffer() {
    if (isDismissed() || location.pathname !== initialPath || document.hidden) return;
    // Preserve the existing exclusion for known Klaviyo profiles.
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') {
      if (++attempts < 30) setTimeout(showOffer, 2000);
      return;
    }
    try {
      if (await window.klaviyo.isIdentified()) return;
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      if (cart.item_count > 0 || isDismissed() || location.pathname !== initialPath || document.hidden) return;
      // Do not compete with another dialog or an open cart drawer.
      if ([...document.querySelectorAll('[role="dialog"], dialog[open]')].some(el => el.checkVisibility({ opacityProperty: true, visibilityProperty: true }))) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch (_) { /* Fail closed if eligibility cannot be checked. */ }
  }
  setTimeout(showOffer, 5000);
})();
